import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../MyComponents/Footer";
// import GuestNav from "../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../MyComponents/Hero2";
import heroContent from "./HeroContent";
import leftimgs from "../../assets/engineeringLeftImg.png";
import rightimgs from "../../assets/engineeringRightImg.png";
// import engineer1 from "../../assets/Engineer1.png";
// import engineer2 from "../../assets/Engineer2.png";
// import engineer3 from "../../assets/Engineer3.png";
// import engineer4 from "../../assets/Engineer4.png";
// import CourseExplorer from "../../MyComponents/CourseExplorer";
import LearningStyle from "../../MyComponents/LearningStyle";
import Testimonials from "../../MyComponents/Testimonials";
import FAQs from "../../MyComponents/FooterPages/newfaq";
import HeadSection from "../HeadSection.js";
import pencilIcon from "../../assets/pencil.png";
import API_CONFIG from "../../config/api";
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import { Link } from "react-router-dom";
// import img1 from "../../assets/Enginerring/Group 22.png"
// import img2 from "../../assets/Enginerring/Rectangle 5.png"
// import img3 from "../../assets/Enginerring/Group 22-1.png"
// import img4 from "../../assets/Enginerring/Group 22-2.png"

// import icon1 from "../../assets/Enginerring/Group 1686552224.png"
// import icon2 from "../../assets/Enginerring/Clip path group-3.png"
// import icon3 from "../../assets/Enginerring/Group 1686552225.png"
// import icon4 from "../../assets/Enginerring/Mask group-1.png"
const courses = [
  {
    title: "Electrical Engineering",
    image: "Polymath-images/Enginerring/Group 22.png",
    icon: "Polymath-images/Enginerring/Group 1686552224.png",
    color: "#d4149aff",
    age: "Age: 12+",
    link: "/engineering_civil"
  },
  {
    title: "Mechanical Engineering (Coming Soon)",
    image: "Polymath-images/Enginerring/Rectangle 5.png",
    icon: "Polymath-images/Enginerring/Clip path group-3.png",
    color: "#9956bbff",
    age: "Age: 12+",
    // link: "/comm_comm_skills"
  },
  {
    title: "Electrical Engineering (Coming Soon)",
    image: "Polymath-images/Enginerring/Group 22-1.png",
    icon: "Polymath-images/Enginerring/Mask group-1.png",
    color: "#14a8b3ff",
    age: "Age: 12+",
    // link: "/graphic_designing_corel" 
  },
  {
    title: "IoT & Robotics (Coming Soon)",
    image: "Polymath-images/Enginerring/Group 22-2.png",
    icon: "Polymath-images/Enginerring/Mask group-1.png",
    color: "#1e830aff",
    age: "Age: 12+",
    // link: "/coding_web_development"
  }


];
const EngineeringPopularCourses = () => {
  const navigate = useNavigate();

  const handleBookDemoClick = () => {
    navigate("/BookADemo");
  };
  return (
    <div className="stem-container">
      <h1 className="stem-title-1">Explore Our Fun & Skill-Boosting </h1>
      <h1 className="stem-title">Engineering Courses</h1>
      <div className="courses-grid">
        {courses.map((course) => (
          <div key={course.title} className="course-card">
            <Link to={course.link} className="course-link">

              <div className="course-image-container">
                <img
                  src={`${API_CONFIG.IMAGES_URL}/${course.image}`}
                  alt={course.title}
                  className="course-image"
                />
                <span className="ages-badge">{course.age}</span>
              </div>

              <div className="icon-container" style={{ backgroundColor: course.color }}>
                <img src={`${API_CONFIG.IMAGES_URL}/${course.icon}`} alt={`${course.title} icon`} className="course-icon" />
              </div>

              <p className="course-title">{course.title}</p>
            </Link>
          </div>
        ))}
      </div>
      <button className="pocustom-btn yellow-btn" onClick={handleBookDemoClick}>
        <img src={pencilIcon} alt="icon" className="pobtn-icon" />
        Book Free Demo Class
      </button>
    </div>
  );
};


const EngineeringPortal = () => {
  const engineeringpage = heroContent.engineeringpage;
  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
        leftImg={"Polymath-images/engineeringLeftImg.png"}
        rightImg={'Polymath-images/engineeringRightImg.png'}
        titlePart1="Empowering Young Minds"
        titlePart2="Through Engineering"
        description="In today's rapidly advancing world, understanding engineering and technology is more important than ever. At Polymath-Kids, we offer hands-on, age-appropriate engineering courses that introduce children to real-world concepts in a fun and engaging way."
        button1Text={false}
        button2Text="Book Free Demo Class"
        button1Icon={'Polymath-images/pencil.png'}
        button2Icon={'Polymath-images/pencil.png'}
        onButton1Click={() => alert("Early bird discount clicked!")}
        onButton2Click={() => alert("Book demo clicked!")}
      />
      <EngineeringPopularCourses />

      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default EngineeringPortal;
